import {DCSP} from 'data/BusinessConstants';

export interface AppConfigProps {
  enableIncoterm: boolean;
  ignoreEquipmentServiceError: boolean;
  enableCurrencyCheck: boolean;
  rfiEnabledFor: string[];
  rfiSuppliersFilterEnabled: boolean;
  rfiReplyAllEnabled: boolean;
  enableChangeOrder: boolean;
  enableMacro: boolean;
  isLargeFolderEnabled: boolean;
}

/**
 * Map from argo app stage to configuration
 */
export const AppConfigMap: Record<string, AppConfigProps> = {
  'dev.cell-0': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'alpha.cell-0': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'beta.cell-0': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'beta.cell-1': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'prod.cell-0': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'prod.cell-1': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'prod.cell-2': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: false,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'prod.cell-3': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: true,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  },
  'prod.cell-4': {
    enableIncoterm: true,
    ignoreEquipmentServiceError: false,
    enableCurrencyCheck: true,
    rfiEnabledFor: [DCSP],
    rfiSuppliersFilterEnabled: true,
    rfiReplyAllEnabled: true,
    enableChangeOrder: true,
    enableMacro: true,
    isLargeFolderEnabled: true
  }
};

export type StageKey = keyof typeof AppConfigMap;
export type AppConfigKey = keyof AppConfigProps;
